import { SubscriptionPlan } from "@workspace/types";
import { clientFetcher } from "./client-fetcher";

export const getSubscriptionStatus = async (workspace_id: string) => {
  return (
    await clientFetcher.get("/workspaces/subscription/status", {
      params: { workspace_id },
    })
  ).data;
};

export const createCheckoutSession = async (
  workspace_id: string,
  plan: SubscriptionPlan,
) => {
  return (
    await clientFetcher.post("/workspaces/subscription/checkout-session", {
      workspace_id,
      plan,
      success_url: typeof window !== "undefined" ? window.location.href : "",
      cancel_url: typeof window !== "undefined" ? window.location.href : "",
    })
  ).data;
};

export const createCustomerPortalUrl = async (workspace_id: string) => {
  return (
    await clientFetcher.post(
      "/workspaces/subscription/customer-portal",
      {},
      {
        params: {
          workspace_id,
          return_url: typeof window !== "undefined" ? window.location.href : "",
        },
      },
    )
  ).data;
};

export const updateSubscriptionPlan = async (
  workspace_id: string,
  new_plan: SubscriptionPlan,
) => {
  return (
    await clientFetcher.post("/workspaces/subscription/update-plan", {
      workspace_id,
      new_plan,
    })
  ).data;
};
